<template>
  <form @submit.prevent="onContinue">
    <p class="pb-4 font-bold md:text-2.5xl md:pb-6 text-sn-gray-900">
      {{ tr('pages.sales.buy.selector.title') }}
    </p>
    <div class="flex flex-wrap justify-between mb-4">
      <TextInput
        v-model="desiredAmount"
        :placeholder="tr('pages.sales.buy.desiredAmount.label')"
        :label="tr('pages.sales.buy.desiredAmount.label')"
        :error="desiredAmountError"
      />
    </div>

    <Alert
      class="my-8"
      variant="info"
      :title="tr('pages.sales.buy.disclaimer.title')"
      :message="tr('pages.sales.buy.disclaimer.text')"
    />

    <div class="max-w-70">
      <Button
        variant="primary"
        :loading="isLoading"
        type="submit"
      >
        {{ tr('pages.sales.buy.selector.continue') }}
      </Button>
    </div>
  </form>
</template>

<script>
import TextInput from '~brand-components/brussels/shared/text-input.vue'
import VoucherAmountSelector from '~brand-components/base/sale/voucher-amount-selector'
import Alert from '~brand-components/brussels/alert/alert'
import Button from '~brand-components/brussels/button/button.vue'
export default VoucherAmountSelector.extend({
  components: {
    TextInput,
    Alert,
    Button,
  },
  computed: {
    currencyOptions() {
      return [
        { code: 'eur', label: 'EUR' },
      ]
    },
    defaultCurrency() {
      return 'eur'
    },
  },
})
</script>
